import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import ClinvarButton from "../../../clinvar-submissions/ClinvarButton";
import { dataHelpTourText } from "./Constants";
import isUserLoggedIn from "../../../../common/helpers/isUserLoggedIn";

const Button = (props) => {
  const {
    element,
    toggleLoginModal,
    toggleModal,
    userFlag,
    editLinkText,
    addLinkText,
    addToHelpTour,
  } = props;

  const clickEvent = isUserLoggedIn() ? toggleModal : toggleLoginModal;

  let btn;

  if (element) {
    btn = <div onClick={clickEvent}>{element}</div>;
  } else {
    btn = (
      <div className="tw-inline-flex">
        <button className="btn btn-success" type="button" onClick={clickEvent}>
          <FontAwesomeIcon
            icon={faFlag}
            fixedWidth={true}
            className="tw-text-white tw-mr-1"
          />
          {userFlag
            ? editLinkText || "Edit Classification"
            : addLinkText || "Classify this variant"}
        </button>
        {__IS_COMPONENTS_PORTAL__ && (
          <span className="tw-ml-3">
            <ClinvarButton
              type="primary"
              analyticsLocation="classification modal in Clinical"
            />
          </span>
        )}
      </div>
    );
  }
  return addToHelpTour ? (
    <div
      className="saph-white-ghost help-tour wizard-Classify-button"
      data-helptour={dataHelpTourText}
      data-helptour-version="6.3.1"
      data-helppos="2"
      onClick={clickEvent}
    >
      <i className="tw-mr-1 fa fa-flag-o" />
      {userFlag
        ? editLinkText || "Edit classification"
        : addLinkText || "Classify"}
    </div>
  ) : (
    btn
  );
};

Button.propTypes = {
  toggleLoginModal: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  element: PropTypes.element,
  editLinkText: PropTypes.bool,
  addLinkText: PropTypes.bool,
  userFlag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ]),
  addToHelpTour: PropTypes.bool,
};

Button.defaultProps = {
  element: null,
  editLinkText: false,
  addLinkText: false,
  userFlag: null,
  addToHelpTour: false,
};

export default Button;
